<div class="container">
    <div fxLayout="row" fxLayoutGap="20px">
        <button mat-raised-button color="primary" (click)="addNew()">Add New</button>
        <!-- <button mat-raised-button color="primary" (click)="vehicleGroup()">Vehicle Groups</button>
        <button mat-raised-button color="primary" (click)="corporateGroup()">Corporate Group</button> -->
    </div>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
       
        <ng-container matColumnDef="corporate_count">
            <th mat-header-cell *matHeaderCellDef> Corporate Count </th>
            <td mat-cell *matCellDef="let element"> {{element.corporate_count}} </td>
        </ng-container>
        
        <ng-container matColumnDef="vehicle_count">
            <th mat-header-cell *matHeaderCellDef> Vehicle Count </th>
            <td mat-cell *matCellDef="let element"> {{element.vehicle_count}} </td>
        </ng-container>




        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="tableClick(row.id)"></tr>
    </table>

</div>